import { createSlice } from '@reduxjs/toolkit';
import { IReadingsState } from './types';

const name = 'worksheetEditor.psdHydrometerReadings';

const initialState: IReadingsState = {
  hydrometerWorksheetReadingManagement: {
    status: {
      creating: false,
    },
  },
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    initTempReadings: (state) => {},
    createReadingsForTimeSequence: (state) => {
      state.hydrometerWorksheetReadingManagement.status.creating = true;
    },
    createReadingsForTimeSequenceResolve: (state) => {
      state.hydrometerWorksheetReadingManagement.status.creating = false;
    },
    createReadingsForTimeSequenceReject: (state) => {
      state.hydrometerWorksheetReadingManagement.status.creating = false;
    },
  },
});

const { actions, reducer } = slice;

export { actions, reducer };
